import React from 'react';

export interface IFeatureFlagContext {
  featureFlags: string[];
}

export const FeatureFlagContext = React.createContext<IFeatureFlagContext>({
  featureFlags: [],
});

export const FeatureFlagProvider: React.FC<React.PropsWithChildren<IFeatureFlagContext>> = ({
  featureFlags,
  children,
}) => {
  return <FeatureFlagContext.Provider value={{ featureFlags }}>{children}</FeatureFlagContext.Provider>;
};
